<template>
  <b-input-group class="counter-input-group">
    <b-input-group-prepend>
      <b-button :variant="variant"
                :disabled="disabled"
                @click="decrementValue">-
      </b-button>
    </b-input-group-prepend>

    <b-form-input type="text"
                  @focus.native="isFocused = true"
                  @blur.native="isFocused = false"
                  :disabled="disabled"
                  number
                  @keydown="keydown"
                  :value="value"
                  @input="onInput"/>

    <b-input-group-append>
      <b-button :variant="variant"
                :disabled="disabled"
                @click="incrementValue">+
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  name: "NumberSpinner",
  props: {
    disabled: Boolean,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1000000000
    },
    step: {
      type: Number,
      default: 1
    },
    value: [String, Number]
  },
  data() {
    return {
      isFocused: false,
      state: null
    }
  },
  methods: {
    onInput(newVal) {
      this.$emit('input', newVal);
      this.validate(newVal);
    },
    keydown(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 189 && charCode !== 109) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    decrementValue() {
      var current = Number.parseInt(this.value);

      if (Number.isNaN(current)) {
        this.$emit('input', 0);
        this.$emit('valid');
        return;
      }

      if (current > this.max) {
        this.$emit('input', this.max);
      } else if (current > this.min) {
        this.$emit('input', current - this.step);
      }

      this.$emit('valid');
    },
    incrementValue() {
      var current = Number.parseInt(this.value);

      if (Number.isNaN(current)) {
        this.$emit('input', 1);
        this.$emit('valid');
        return;
      }

      if (current < this.max) {
        this.$emit('input', current + this.step);
      } else {
        this.$emit('input', this.max);
      }

      this.$emit('valid');
    },
    validate(value) {
      var valueToParse = value || this.value;

      if (valueToParse === '') {
        this.$emit('invalid');
        this.state = false;
        return;
      }

      var numberValue = Number.parseInt(value || this.value);

      if (numberValue > this.max) {
        this.$emit('invalid');
        this.state = false;
        return;
      }

      if (numberValue < this.min) {
        this.$emit('invalid');
        this.state = false;
        return;
      }

      this.$emit('valid');
      this.state = null;
    }
  },
  computed: {
    variant() {
      if (this.isFocused) {
        return 'outline-ls'
      }

      return null;
    }
  },
  watch: {
    value() {
      this.validate()
    },
    state(newVal) {
      if (newVal === false) {
        this.$emit('invalid');
      } else {
        this.$emit('valid');
      }
    }
  }
}
</script>

<style scoped>
.counter-input-group >>> .number-input.form-control {
  padding: 0 !important;
}

.counter-input-group >>> .number-input__input {
  height: calc(2.95rem);
  border: none !important;
}

.counter-input-group >>> .number-input__input:focus {
  border: 1px solid var(--accent-color) !important;
  box-shadow: unset !important;
}

.counter-input-group >>> .number-input.is-invalid input {
  border: 1px solid #f4516c !important;
}

.counter-input-group >>> .number-input.is-invalid input:focus {
  box-shadow: 0 .2rem .2rem -.2rem red !important;
}

/* Chrome, Safari, Edge, Opera */
.counter-input-group >>> input::-webkit-outer-spin-button, .counter-input-group >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.counter-input-group >>> input[type=number] {
  -moz-appearance: textfield;
}
</style>
